import {GridReadyEvent, IServerSideGetRowsParams} from "ag-grid-community";
import {RefObject, useCallback} from "react";
import {AgGridReact} from "ag-grid-react";
import {PagedResponse} from "../api/types/pagination";
import {PeakEntityResponse} from "../api/types/peak";

export type datasource<T, F> = {
    api: (args: F) => Promise<PagedResponse<T>>;
    gridRef: RefObject<AgGridReact<T>>;
    initialSortColId: string
    entityFilters: F
    customSort: string
};

// const emptyPagedResponse: PagedResponse<PeakEntityResponse> = {
//     totalElements: 0,
//     totalPages: 0,
//     size: 0,
//     content: [],
//     number: 0,
//     sort: {
//         empty: true,
//         sorted: false,
//         unsorted: true,
//     },
//     numberOfElements: 0,
//     pageable: {
//         offset: 0,
//         sort: {
//             empty: true,
//             sorted: false,
//             unsorted: true,
//         },
//         pageNumber: 0,
//         paged: true,
//         unpaged: false,
//         pageSize: 0,
//     },
//     first: true,
//     last: false,
//     empty: true,
// }

const useAgGridCustomHook = <T, F>({
                                       api,
                                       gridRef,
                                       initialSortColId,
                                       entityFilters,
                                       customSort
                                   }: datasource<T, F>) => {
    const getRows = async (params: IServerSideGetRowsParams<T>) => {
        let sort = params.request.sortModel[0]?.colId || null;
        let order = params.request.sortModel[0]?.sort || null;

        const {filterModel} = params.request;

        const filter: F = Object.entries(filterModel as Record<string, { filter?: string; type: string }>).reduce((acc, [key, value]) => ({
            ...acc,
            [key]: value?.filter || ""
        }), entityFilters);

        function getCustomSort() {
            let currentSort = sort;
            switch (customSort) {
                case "AncillaryEntityResponse": {
                    switch (sort) {
                        case "ancillaryCode": {
                            currentSort = "code";
                            break;
                        }
                        case "pickupDateFrom": {
                            currentSort = "pickupFrom";
                            break;
                        }
                        case "pickupDateTo": {
                            currentSort = "pickupTo";
                            break;
                        }
                        case "legalEntities": {
                            currentSort = "legalEntity";
                            break
                        }
                        case "dealers": {
                            currentSort = "dealer";
                            break
                        }
                    }
                    break;
                }
                case "AncillaryExceptionEntityResponse": {
                    switch (sort) {
                        case "ancillaryId": {
                            currentSort = "prcAncillary_nameAncillary";
                            break;
                        }
                        case "commercialCategoryId": {
                            currentSort = "commercialCategory";
                            break;
                        }
                        case "commercialSegmentId": {
                            currentSort = "commercialSegment";
                            break;
                        }
                        case "pickupDateFrom": {
                            currentSort = "pickupFrom";
                            break;
                        }
                        case "pickupDateTo": {
                            currentSort = "pickupTo";
                            break;
                        }
                        case "legalEntities": {
                            currentSort = "legalEntity";
                            break
                        }
                        case "dealers": {
                            currentSort = "dealer";
                            break
                        }
                    }
                    break;
                }
                case "OWAncillaryEntityResponse": {
                    switch (sort) {
                        case "prcAncillary.nameAncillary": {
                            currentSort = "prcAncillary_nameAncillary";
                            break;
                        }
                        case "ancillaryCode": {
                            currentSort = "prcAncillary_code";
                            break;
                        }
                        case "pickupDateFrom": {
                            currentSort = "prcAncillary_pickupFrom";
                            break;
                        }
                        case "pickupDateTo": {
                            currentSort = "prcAncillary_pickupTo";
                            break;
                        }
                        case "reservationFrom": {
                            currentSort = "prcAncillary_reservationFrom";
                            break;
                        }
                        case "reservationTo": {
                            currentSort = "prcAncillary_reservationTo";
                            break;
                        }
                        case "legalEntities": {
                            currentSort = "legalEntity";
                            break
                        }
                        case "dealers": {
                            currentSort = "dealer";
                            break
                        }
                    }
                    break;
                }
                case "ExceptionListEntityResponse": {
                    switch (sort) {
                        case "listName": {
                            currentSort = "name";
                            break;
                        }
                        case "legalEntities": {
                            currentSort = "legalEntity";
                            break
                        }
                        case "dealers": {
                            currentSort = "dealer";
                            break
                        }
                    }
                    break;
                }
                case "OWAncillaryExceptionEntityResponse": {
                    switch (sort) {
                        case "commercialSegmentId": {
                            currentSort = "commercialSegment";
                            break;
                        }
                        case "commercialCategoryId": {
                            currentSort = "commercialCategory";
                            break;
                        }
                        case "ancillaryId": {
                            currentSort = "prcAncillary_nameAncillary";
                            break;
                        }
                        case "pickupDateFrom": {
                            currentSort = "pickupFrom";
                            break;
                        }
                        case "pickupDateTo": {
                            currentSort = "pickupTo";
                            break;
                        }
                        case "legalEntities": {
                            currentSort = "legalEntity";
                            break
                        }
                        case "dealers": {
                            currentSort = "dealer";
                            break
                        }
                    }
                    break;
                }
                case "RentalPeriodEntityResponse": {
                    switch (sort) {
                        case "tpUnitId": {
                            currentSort = "tpUnit";
                            break;
                        }
                        case "showActive": {
                            currentSort = "active";
                            break;
                        }
                        case "legalEntities": {
                            currentSort = "legalEntity";
                            break
                        }
                        case "dealers": {
                            currentSort = "dealer";
                            break
                        }
                    }
                    break;
                }
                case "RateEntityResponse": {
                    switch (sort) {
                        case "commercialSegmentId": {
                            currentSort = "commercialCategory_commercialSegment";
                            break;
                        }
                        case "commercialCategoryId": {
                            currentSort = "commercialCategory";
                            break;
                        }
                        case "legalEntities": {
                            currentSort = "legalEntity";
                            break
                        }
                        case "dealers": {
                            currentSort = "dealer";
                            break
                        }
                    }
                    break;
                }
                case "ExcessGroupEntityResponse": {
                    switch (sort) {
                        case "commercialSegmentId": {
                            currentSort = "commercialCategory_commercialSegment";
                            break;
                        }
                        case "commercialCategoryId": {
                            currentSort = "commercialCategory";
                            break;
                        }
                        case "legalEntities": {
                            currentSort = "legalEntity";
                            break
                        }
                        case "dealers": {
                            currentSort = "dealer";
                            break
                        }
                    }
                    break;
                }
                case "UpsellingRateEntityResponse": {
                    switch (sort) {
                        case "commercialCategoryId": {
                            currentSort = "commercialCategory";
                            break;
                        }
                        case "legalEntities": {
                            currentSort = "legalEntity";
                            break
                        }
                        case "dealers": {
                            currentSort = "dealer";
                            break
                        }
                    }
                    break;
                }
                case "PeakEntityResponse": {
                    switch (sort) {
                        case "commercialCategoryId": {
                            currentSort = "commercialCategory";
                            break;
                        }
                    }
                    break;
                }
                case "GreenDiscountEntityResponse": {
                    switch (sort) {
                        case "commercialCategoryId": {
                            currentSort = "commercialCategory";
                            break;
                        }
                        case "legalEntities": {
                            currentSort = "legalEntity";
                            break
                        }
                        case "dealers": {
                            currentSort = "dealer";
                            break
                        }
                    }
                    break;
                }
                case "LocationDiscountEntityResponse": {
                    switch (sort) {
                        case "legalEntities": {
                            currentSort = "legalEntity";
                            break
                        }
                        case "dealers": {
                            currentSort = "dealer";
                            break
                        }
                        case "lppProfileIds": {
                            currentSort = "idLppProfile";
                            break
                        }
                        case "validityTo": {
                            currentSort = "validityDateTo";
                            break
                        }
                        case "validityFrom": {
                            currentSort = "validityDateFrom";
                            break
                        }
                        case "locationCodes": {
                            currentSort = "prcLocation_name";
                            break
                        }
                        case "discounts": {
                            currentSort = "discount";
                            break
                        }
                    }
                }
            }

            return currentSort;
        }

        // const entityPaged = customSort === "PeakEntityResponse" ? emptyPagedResponse : await api({
        const entityPaged = await api({
            ...filter,
            sort: sort && order ? `${customSort ? getCustomSort() : sort},${order}` : "",
            size: gridRef?.current?.api?.paginationGetPageSize() || 10,
            page: gridRef?.current?.api?.paginationGetCurrentPage() || 0
        });
        if (entityPaged.totalElements === 0) {
            gridRef.current!.api?.showNoRowsOverlay();
        } else {
            gridRef.current!.api?.hideOverlay();
        }

        params.success({
            rowData: entityPaged.content,
            rowCount: entityPaged.totalElements
        });
    };

    const refresh = useCallback(() => {
        gridRef.current!.api.refreshServerSide({purge: true});
        // eslint-disable-next-line
    }, []);

    const handleTriggerFilters = async (filters: F) => {
        const hardcodedFilter = Object.entries(filters).reduce(
            (acc, [key, value]) => ({
                ...acc,
                [key]: {type: "contains", filter: value}
            }),
            {}
        );

        gridRef.current?.api?.paginationGoToFirstPage();
        await gridRef.current?.api?.setFilterModel(hardcodedFilter);
        gridRef.current?.api?.onFilterChanged();
    };

    const setServerSideDatasource = useCallback((params: GridReadyEvent) => {
        params.columnApi?.applyColumnState({
            state: [{colId: initialSortColId, sort: "asc"}],
            defaultState: {sort: null}
        });
        params.api.setServerSideDatasource({getRows});
        //eslint-disable-next-line
    }, []);

    return {
        datasource: {getRows},
        setServerSideDatasource,
        refresh,
        handleTriggerFilters
    };
};

export default useAgGridCustomHook;
